module.exports = __webpack_public_path__ + "img/agreed-value-coverage@2x.5e6d813f.jpg";